declare const __WIS_BUILD__: string;

export const CLIENT_BUILD: string = typeof __WIS_BUILD__ === 'string' ? __WIS_BUILD__ : 'unknown';

const RELEASE = /^\d+\.\d+\.\d+$/;

export type BuildVerdict = 'match' | 'unstamped' | 'stale' | 'stale-again';

export function compareBuilds(
  client: string,
  server: string,
  alreadyReloadedFor: string | null,
): BuildVerdict {
  if (!RELEASE.test(client) || !RELEASE.test(server)) return 'unstamped';
  if (client === server) return 'match';
  return alreadyReloadedFor === server ? 'stale-again' : 'stale';
}

const KEY = 'wis.buildReload';

function reloadedFor(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function noteReload(server: string): void {
  try {
    sessionStorage.setItem(KEY, server);
  } catch {
    return;
  }
}

export function checkServerBuild(
  server: string,
  reload: () => void,
  warn: (message: string) => void,
): BuildVerdict {
  const verdict = compareBuilds(CLIENT_BUILD, server, reloadedFor());
  if (verdict === 'stale') {
    noteReload(server);
    reload();
  } else if (verdict === 'stale-again') {
    warn(`This page is build ${CLIENT_BUILD} but the server runs ${server}. Reload to update.`);
  }
  return verdict;
}
